import { render, staticRenderFns } from "./feed-item.vue?vue&type=template&id=2874de83&scoped=true&"
import script from "./feed-item.vue?vue&type=script&lang=js&"
export * from "./feed-item.vue?vue&type=script&lang=js&"
import style0 from "./feed-item.vue?vue&type=style&index=0&id=2874de83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874de83",
  null
  
)

export default component.exports